import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GestionStockTab } from './logiciel-caisse-gestion-stock.component';

@Component({
  selector: 'app-logiciel-caisse-gestion-stock-tab',
  template: `
    <div class="container-fluid p-0 m-0">
      <app-logiciel-caisse-gestion-stock-content [tab]="tab"></app-logiciel-caisse-gestion-stock-content>
    </div>
  `,
})
export class LogicielCaisseGestionStockTabComponent implements OnInit {
  tab: GestionStockTab = 'actif';

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const fromData = data['tab'] as GestionStockTab | undefined;
      this.tab = fromData === 'archive' ? 'archive' : 'actif';
    });
  }
}
